import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconPower = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      viewBox="0 0 24 25"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_4904_59374)">
        <path
          d="M12 2.09082V11.8408"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00002 5.60376C6.99838 6.31145 5.31136 7.70397 4.23712 9.5352C3.16289 11.3664 2.77062 13.5185 3.12963 15.611C3.48865 17.7034 4.57583 19.6016 6.19904 20.9701C7.82224 22.3385 9.87696 23.089 12 23.089C14.1231 23.089 16.1778 22.3385 17.801 20.9701C19.4242 19.6016 20.5114 17.7034 20.8704 15.611C21.2294 13.5185 20.8371 11.3664 19.7629 9.5352C18.6887 7.70397 17.0017 6.31145 15 5.60376"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
